import { AREA_LABELS } from '../../copy/investor-copy'
import type { Relationship } from './types'

type Assessment = NonNullable<Relationship['assessment']>
export type AreaRead = Assessment['dimensions'][string]
export interface AreaRow {
  area: string
  read: AreaRead
}

const orderOf = (area: string): number => {
  const index = Object.keys(AREA_LABELS).indexOf(area)
  return index === -1 ? Number.MAX_SAFE_INTEGER : index
}

/** The areas the AI read, in the app's area order. */
export function areaRows(dimensions: Assessment['dimensions']): AreaRow[] {
  return Object.entries(dimensions)
    .map(([area, read]) => ({ area, read }))
    .sort((a, b) => orderOf(a.area) - orderOf(b.area))
}

/** Only the areas that carry a read (a verdict or a finding): the short card lists these. */
export const readAreaRows = (dimensions: Assessment['dimensions']): AreaRow[] =>
  areaRows(dimensions).filter(({ read }) => read.verdict !== null || read.kind !== null)

/** An area the AI named that is not one of ours, with its reasoning when it gave any. */
export function otherAreaRows(
  others: Assessment['otherDimensions']
): { area: string; text: string | null }[] {
  return Object.entries(others).map(([area, value]) => {
    if (typeof value === 'string') return { area, text: value }
    const record = value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
    const text = [record.note, record.reasoning, record.text].find(
      (candidate): candidate is string => typeof candidate === 'string' && candidate.length > 0
    )
    return { area, text: text ?? null }
  })
}
